import * as React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'

import StatsDashboard from './StatsDashboard'
import StatsTopStats from './StatsTopStats'
import ExamStats from './ExamStats'
import PatientStats from './PatientStats'
import ReferringPhysicianStats from './ReferringPhysicianStats'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

export default function Stats() {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          backgroundColor: 'white',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Stats menu"
          centered
        >
          <Tab label="Dashboard" {...a11yProps(0)} />
          <Tab label="Stats examens" {...a11yProps(2)} />
          <Tab label="Stats patients" {...a11yProps(3)} />
          <Tab label="Stats prescripteurs" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <StatsDashboard></StatsDashboard>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ExamStats></ExamStats>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <PatientStats></PatientStats>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <ReferringPhysicianStats></ReferringPhysicianStats>
      </CustomTabPanel>
    </Box>
  )
}
